import React, { forwardRef } from "react";
import styled from "styled-components";
import { Colors } from "../../config/Constants";
const datepickerImage = require("../../assets/images/datepicker-icon.png");

interface InputProps {
  value: string;
  onChange: (value: any) => void;
  onClick: () => void;
  disabled: boolean;
  outlined: boolean;
  width: string;
  ghostText?: string;
  error?: string;
}

const InputDatePicker = (
  {
    value,
    onClick,
    onChange,
    disabled,
    outlined,
    width,
    ghostText,
    error,
  }: InputProps,
  ref: any
) => {
  return (
    <StyledInput
      error={error}
      type="text"
      value={value}
      className="custom-input"
      ref={ref}
      onChange={(e) => onChange(e.target.value)}
      onClick={onClick}
      disabled={disabled}
      placeholder={ghostText || "Select date"}
      outlined={outlined}
      width={width}
    />
  );
};

export default forwardRef(InputDatePicker);

interface InputProps {
  outlined: boolean;
  width: string;
  ghostText?: string;
}

const StyledInput = styled.input<InputProps>`
  opacity: 1;
  display: block;
  background: ${(props) =>
    props.disabled ? "" : `url(${datepickerImage}) no-repeat right`};
  background-position: calc(100% - 0.625rem);
  margin-top: 0.5rem;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  border: ${(props) =>
    props.error
      ? `1px solid ${Colors.red}`
      : props.outlined
      ? `0.0625rem solid ${Colors.athensGrey}`
      : `transparent`};
  border-radius: 0.25rem;
  width: ${(props) => (props.width ? props.width : "100%")};
  height: 2.6875rem;
  // padding-left: 0.625rem;
  padding-left: ${(props) => (props.outlined ? `0.625rem` : `0`)};
  font-family: "Poppins-Medium";
  font-size: 0.8125rem;
  color: ${Colors.secondaryBlack};
  :focus {
    outline: none;
  }
  ::placeholder {
    font-family: "Poppins-Book";
    font-size: 0.8125rem;
    color: ${Colors.cloudyGrey};
  }
`;
